
import {
  computed, defineComponent, onBeforeMount, reactive,
} from 'vue';
import {
  IColaboradorComissao, IColaboradorComissaoParticipante, IColaboradorComissaoUnidade,
} from '@/models/Entidades/Cadastros/Pessoas/Colaboradores/IColaboradorComissao';
import { IColumn } from '@/core/models/AntDesign/IColumn';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IDTOCategoriaComissao } from '@/models/DTO/Cadastros/Pessoas/Colaboradores/IDTOCategoriaComissao';
import Icone from '@/core/components/Icone.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import Card from '@/core/components/Tela/Card.vue';

export default defineComponent({
  name: 'ComissaoCategoria',
  props: {
    categorias: {
      type: Array as () => IDTOCategoriaComissao[],
      required: true,
    },
  },
  components: {
    Icone,
    CampoNumerico,
    Card,
  },
  emits: ['update:categorias'],
  setup(props, { emit }) {
    const {
      apresentarMensagemAlerta,
    } = useTelaBase();

    const state = reactive({
    });

    const computedCategorias = computed({
      get: () => props.categorias,
      set: (valor: IDTOCategoriaComissao[]) => {
        emit('update:categorias', valor);
      },
    });

    function zerarPercentual(index: number) {
      computedCategorias.value[index].percentualComissao = 0;
    }

    function expandir(index: number) {
      computedCategorias.value[index].expandir = !computedCategorias.value[index].expandir;
    }

    onBeforeMount(async () => {
      // console.log
    });

    return {
      props,
      state,
      computedCategorias,
      UtilitarioGeral,
      zerarPercentual,
      expandir,
    };
  },
});
